import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IUserTasksCapacity } from '../models/user-tasks-capacity.model';

@Injectable()
export abstract class IUserTasksCapacityService {
  public abstract capacity$: Observable<IUserTasksCapacity>;
  public abstract initialize(): void;
}
